<template>
  <div>
    <a-modal
      :centered="true"
      width="587px"
      class="filterModalContainer1 mobile-modal-fullscreen"
      v-model:showModal="showModal"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      :closable="false"
    >
      <div class="container-meet">
        <!-- <p class="heading">Filter</p> -->
        <!-- <div
            v-for="filter_item in filter_item_list"
            :key="filter_item"
            class="filter-item"
          > -->
        <!-- <a-checkbox class="checkbox">{{ filter_item }}</a-checkbox> -->

        <div class="d-flex align-items-center" :style="{ padding: '24px' }">
          <font-awesome-icon
            size="2x"
            :icon="['fal', 'times']"
            class="show-in-mobile font-black mr-3"
            @click="hide()"
          />
          <h4 class="fw700 font24 gray700 mb-0">Filter</h4>
          <button
            class="fw700 btn font-white p1224 font14 br6 show-in-mobile ml-auto"
            @click="handleSubmit()"
            :style="{ background: getPrimaryColor() }"
          >
            Submit
          </button>
          <font-awesome-icon
            size="2x"
            :style="{ cursor: 'pointer' }"
            :icon="['fal', 'times']"
            class="hide-in-mobile font-black ml-auto"
            @click="hide()"
          />
        </div>
        <div class="filters-container">
          <div class="mb-2 input-name">
            <label for="age" class="mb-1 font-weight-bold">Clinic name</label>
            <a-input
              type="search"
              class=" w-100"
              placeholder="Enter clinic name"
              :value="searchName"
              @change="handleSearchClinic"
              @keyup.enter="handleSearchClinic"
            />
          </div>
          <div class=" text-left pb-2 disease-input">
            <label for="age" class="mb-1 font-weight-bold"
              >City and state</label
            >
            <div class="search-input position-relative w-100">
              <font-awesome-icon
                :icon="['fal', 'search']"
                :style="{ color: '#94A3B8', width: '20px' }"
                class="position-absolute search-icon"
              />
              <a-select
                show-search
                class="input-select-dropdown w-100"
                size="large"
                placeholder="Search city"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :value="searchCity ? searchCity + ' , ' + searchState : undefined"
                @search="handleSelectLocation"
                @select="(val) => selectLocation(val)"
                :getPopupContainer="trigger => trigger.parentNode"
              >
                <a-select-option v-for="d in locationList" :key="JSON.stringify(d)">
                  {{ d.city }}, {{ d.state }}
                </a-select-option>
              </a-select>
            </div>
          </div>
         
          <!-- <a-checkbox-group
            class="sub-type"
            v-model="sub_type"
            :options="Options"
          /> -->

          <!-- <div
              class=" text-left pb-2 meetinput "
              :style="{
                marginTop: circleDiseaseTypes.length > 0 ? '24px' : '0px'
              }"
            >
              <label for="age" class="mb-1 font-weight-bold">Age</label>
              <a-select
                placeholder="Select age range"
                class="w-100"
                style="width: 539px"
                v-model="Age"
              >
                <a-select-option value="">Select</a-select-option>
                <a-select-option value="10">0-10</a-select-option>
                <a-select-option value="20">11-20</a-select-option>
                <a-select-option value="30">21-30</a-select-option>
                <a-select-option value="40">31-40</a-select-option>
                <a-select-option value="50">41-50</a-select-option>
                <a-select-option value="60">51-60</a-select-option>
                <a-select-option value="70">61-70</a-select-option>
                <a-select-option value="80">71-80</a-select-option>
                <a-select-option value="90">81-90</a-select-option>
                <a-select-option value="100">91-100</a-select-option>
              </a-select>
            </div> -->

          <!-- <div class=" text-left pb-2 meetinput input">
              <label for="username" class="mb-1 font-weight-bold">Gender</label>
              <a-select
                placeholder="Select gender"
                class="w-100"
                style="width: 539px"
                v-model="Gender"
              >
                <a-select-option value="">Select</a-select-option>
                <a-select-option value="male">Male</a-select-option>
                <a-select-option value="female">Female</a-select-option>
                <a-select-option value="other">other</a-select-option>
              </a-select>
            </div> -->
            <div>
            <a-checkbox class="sub-type" v-model:recommend="recommend"
        >Is Recommended</a-checkbox
      >
      <a-checkbox class="sub-type" v-model:premium="premium"
        >Is Premium</a-checkbox
      >
      <a-checkbox class="sub-type" v-model:claimed="claimed"
        >Is Claimed</a-checkbox
      >
    </div>
      
          <div class="clear-filters" @click="clearfilters">
            <p class="clear-text">Clear filters</p>
          </div>
        </div>
        <div class="footer">
          <button class="cancel" @click="hide()">Cancel</button>
          <button
            class="apply"
            @click="handleSubmit"
            :style="{ background: getPrimaryColor() }"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const AppRepository = RepositoryFactory.get("app");
export default {
  name: "ClinicDirectoryFilter",
  props: {
    handleAnswer: Function,
    searchName: String,
    searchState: String,
    searchCity: String,
    locationList: Array,
    handleSelectLocation: Function,
    recommend : Boolean ,
    claimed : Boolean,
    premium : Boolean
  },
  data() {
    return {
      showModal: false,
      loading: false,
      showFilters: false,
      hideFiltersToggle: false,
      // Gender: undefined,
      // Age: undefined,
      // ibs: undefined,
      Options: ["Is Recommended", "Is Premium", "Is Claimed"],
      sub_type: [],
    };
  },

  components: {},

  // computed: {
  //   ...mapGetters({
  //     circleDiseaseTypes: "Circle/circleDiseaseTypes"
  //   })
  // },

  methods: {
    selectLocation(val) {
      const value = JSON.parse(val);
      this.searchCity = value.city;
      this.searchState = value.state;
    },
    show() {
      this.showModal = true;
      //   if (this.clearfilter == true) {
      //     this.state = undefined;
      //   }
    },
    hide() {
      this.showModal = false;
      this.searchCity = "";
      this.searchState = "";
      this.searchName = "";
      this.recommend = false ;
      this.premium = false ;
      this.claimed = false ;
      // this.Gender = undefined;
      // this.Age = undefined;
      // this.ibs = undefined;
    },

    clearfilters() {
      this.searchCity = "";
      this.searchState = "";
      this.searchName = "";
      this.recommend = false ;
      this.premium = false ;
      this.claimed = false ;
      this.sub_type = [];
      this.handleAnswer();
    },
    handleSearchClinic(e) {
      this.searchName = e.target.value;
      console.log(this.searchName);
    },

    handleSubmit() {
      // console.log("Apply", this.Gender, this.Age, this.ibs, this.clearfilter);
      this.handleAnswer(this.searchState, this.searchCity, this.searchName,this.claimed,this.premium,this.recommend);
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 427px) {
  .container-meet {
    height: 100vh !important;
  }
  .clear-filters {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    background: #e2e8f0;
    border-radius: 6px;
    height: 48px;
    margin-top: 24px;
  }
  .clear-text {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #47556e;
    margin-bottom: 0px;
  }

  .footer {
    display: none !important;
  }
}
.input-name input {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  height: 56px;
  background: #ffffff;
  color: #94a3b8;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  outline: none;
}
.sub-type {
  display: block;
  margin-bottom: 16px;
  margin-left: 0px;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #647490;
  width: fit-content;
}

.btn {
  border-radius: 6px;
  font-size: 14px;
  line-height: 24px;
  border: none;
}

.clear-filters {
  display: none;
}
.search-input {
  display: flex;
  align-items: center;
  position: relative;
}
.search-icon {
  left: 5px;
  font-size: 20px;
  color: #94a3b8;
  z-index: 1;
  margin-left: 12px;
}

.heading {
  font-family: "Lato";
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #33415f;
  padding: 24px;
}

.footer {
  padding: 24px;
  display: flex;
  justify-content: flex-end;
}
.checkbox span {
  border: 2px solid #94a3b8;
  border-radius: 2px;
}
.meetinput {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
}
.fw700 {
  font-weight: 700;
}
.input {
  margin-top: 24px;
}
.filters-container {
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  margin-right: 24px;
  gap: 24px;
}

.cancel {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: #47556e;
  margin-right: 10px;
}

.search-icon {
  left: 5px;
  font-size: 20px;
  color: #647490;
  z-index: 1;
  margin-left: 5px;
}
.apply {
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  background: #2a71d4 !important;
}

.filter-item {
  border: none;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #0f1734;
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.question_category {
  margin-top: 24px;
  margin-left: 24px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ClinicDirectoryFilter.vue